/* eslint-disable no-param-reassign, no-use-before-define */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { initialize } from "../../actions";
import { FEATURE_NAME, withNamespace } from "../../constants/namespace";
import { CREATE_LISTING_AGENT_MATCH_ON_HDP_CONNECTION } from "../../graphql-documents/createListingAgentMatchOnHDPConnection.mutation";

export const createListingAgentMatchConnection = createAsyncThunk(
  withNamespace("createListingAgentMatchConnection"),
  async (data, { extra }) => {
    const {
      analyticsService,
      deviceFingerprintService,
      graphqlMutationService
    } = extra[FEATURE_NAME];

    return graphqlMutationService
      .mutate({
        mutation: CREATE_LISTING_AGENT_MATCH_ON_HDP_CONNECTION,
        variables: {
          agent_name: data.agentName,
          brokerage: data.brokerage,
          brokerage_address: data.brokerageAddress,
          contact_id: data.contactId,
          email: data.email,
          fingerprint_or_device_guid: deviceFingerprintService.get(),
          has_sold_in_building: data.soldHomesInUserBuilding,
          homes_sold_nearby: data.nearbyHomes,
          homes_sold_recent: data.recentHomesSold,
          homes_sold_similar: data.similarHomes,
          is_pro: data.isPro,
          license_type: data.agentTitle,
          median_sales_price: data.medianSalesPrice,
          name: data.name,
          notes: data.message,
          origin_label: "listing_agent_match_hdp",
          phone: data.phoneNumber,
          photo_url: data.agentImageSrc,
          sale_id: data.saleId,
          user_id: data.userId,
          uuid: data.uuid,
          years_experience: data.yearsExperience
        }
      })
      .then(response => {
        const errorsPresent =
          response.data?.create_listing_agent_match_on_hdp_connection?.errors;

        if (!errorsPresent) {
          analyticsService.sendContactListingAgentEvent({
            expertContactId: data.contactId,
            propertyId: data.propertyId,
            uuid: data.uuid
          });
        }

        return response;
      });
  }
);

const initialState = {
  email: "",
  name: "",
  phoneNumber: "",
  userId: null
};

const contactFormSlice = createSlice({
  name: withNamespace("contactForm"),
  initialState,
  extraReducers: {
    [initialize]: (state, action) => {
      state.propertyId = action.payload.propertyId;
      state.saleId = action.payload.saleId;
      state.userId = action.payload.userId ?? initialState.userId;
      state.email = action.payload.email ?? initialState.email;
      state.name = action.payload.name ?? initialState.name;
      state.phoneNumber =
        action.payload.phoneNumber ?? initialState.phoneNumber;
    },
    [createListingAgentMatchConnection.fulfilled]: (state, action) => {
      const errors =
        action.payload?.data?.create_listing_agent_match_on_hdp_connection
          ?.errors;

      const contactId =
        action.payload?.data?.create_listing_agent_match_on_hdp_connection
          ?.contact_id;

      state.errors = errors;
      state.contactId = contactId;
    }
  }
});

export default contactFormSlice.reducer;
